<template lang="">
    <h6 class="text-center text-error font-medium">{{ comment }}.</h6>
</template>
<script>
export default {
    props: {
        order: Object
    },
    computed: {
        comment() {
            let order = this.order;
            let result = order?.comment && order?.comment?.client ? order?.comment?.client : this.$t("popupOrder.rejectedOrder.orderComment");
            return order?.CP_CANCEL_MESSAGE || result;
        }
    }
};
</script>
<style lang="scss">
.rejectedSection {
    text-align: center;
    margin-top: 10px;
}
</style>
